import styled from 'styled-components';

export const MainButton = styled.button<{ disabled?: boolean }>`
  height: 140px;
  margin: 0 auto 0;

  background-color: #efff00;
  font-family: 'Krungthep';
  text-transform: uppercase;
  border: none;
  border-radius: 62px;
  box-shadow: 5px 7px 0 0 #262626;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  color: #262626;
  font-size: 45px;
  font-weight: 600;
  padding: 0 100px;
`;
